/**
 * SMS alert guidance service — migrated to typed `@tiaki/http-client`
 * per ADR 113 §Decision (call-site path autocomplete).
 */
import { client } from '../lib/http-client';

function unwrap<T>(result: { data?: T; error?: unknown }): T {
  if (result.error !== undefined) {
    throw result.error;
  }
  return result.data as T;
}

export interface GuidanceStep {
  id?: number;
  row_type: 'step' | 'header';
  title: string;
  description?: string;
  order: number;
  is_tick_required: boolean;
}

export interface AlertGuidance {
  id?: number;
  title: string;
  plan: string;
  alert_type: number;
  is_default: boolean;
  steps?: GuidanceStep[];
}

export interface AlertGuidanceListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: AlertGuidance[];
}

export async function getAlertGuidances(
  alertTypeId: number,
): Promise<AlertGuidanceListResponse> {
  const result = await client.GET('/api/v2/alert-guidance/', {
    params: { query: { alert_type: alertTypeId } as never },
  });
  return unwrap(result) as unknown as AlertGuidanceListResponse;
}

export async function createAlertGuidance(
  data: Omit<AlertGuidance, 'id'>,
): Promise<AlertGuidance> {
  const result = await client.POST('/api/v2/alert-guidance/', {
    body: data as never,
  });
  return unwrap(result) as unknown as AlertGuidance;
}

export async function updateAlertGuidance(
  id: number,
  data: AlertGuidance,
): Promise<AlertGuidance> {
  const result = await client.PUT('/api/v2/alert-guidance/{id}/', {
    params: { path: { id } as never },
    body: data as never,
  });
  return unwrap(result) as unknown as AlertGuidance;
}

export async function deleteAlertGuidance(id: number): Promise<void> {
  const result = await client.DELETE('/api/v2/alert-guidance/{id}/', {
    params: { path: { id } as never },
  });
  unwrap(result);
}
